import { Observable } from 'rxjs';

import { Unit, UnitCreateParams, UnitUpdateParams } from '../models/unit.model';

export abstract class UnitGateway {
  abstract createUnit(projectId: string, params: UnitCreateParams): Observable<Unit>;
  abstract updateUnit(projectId: string, unitId: string, params: UnitUpdateParams): Observable<Unit>;
  abstract updateUnitAssign(projectId: string, unitId: string): Observable<Unit>;
  abstract deleteUnit(projectId: string, unitId: string): Observable<void>;
}
